import Maskit from '../package';
import './styles.css';
window.addEventListener('load', () => {
    const reRenderCode = (mask) => {
        document.querySelectorAll('.mask-value').forEach((item) => {
            item.innerHTML = mask;
            setTimeout(() => {
                hljs.highlightBlock(item.closest('.code'));
            }, 0);
        });
    };
    const maskInput = document.querySelector('input#mask');
    const mask = maskInput.value;
    const resultInput = document.querySelector('input#result');
    const maskit = new Maskit(resultInput, {
        mask,
        resetOnBlurIfInvalid: true,
        onFilled: ({ instance }) => { },
        offFilled: ({ instance }) => { },
        onBlur: ({ instance }) => { },
        beforeChange: ({ instance, value }) => { },
        onChange: ({ instance }) => { },
        onInit: ({ instance }) => {
            console.log(instance);
            reRenderCode(instance.options.mask);
        },
    });
    document.querySelectorAll('.mask-value').forEach((item) => {
        item.innerHTML = mask;
    });
    maskInput.addEventListener('input', (event) => {
        const { value } = event.target;
        maskit.setValue('');
        maskit.setMask(value);
        reRenderCode(value);
    });
});
